// extracted by mini-css-extract-plugin
export var boldText = "_3m-4";
export var checkboxContainer = "_3m-6";
export var closeIcon = "_3m-g";
export var container = "_3m-0";
export var drawer = "_3m-8";
export var drawerContent = "_3m-9";
export var extraSmallText = "_3m-5";
export var fulfillmentGroupTable = "_3m-e";
export var largeText = "_3m-3";
export var loadingSpinnerContainer = "_3m-h";
export var mediumText = "_3m-2";
export var narrow = "_3m-f";
export var notificationLink = "_3m-j";
export var packageCheckIconContainer = "_3m-7";
export var slideoutHeaderContainer = "_3m-a";
export var slideoutModal = "_3m-c";
export var stickyHeaderWrapper = "_3m-b";
export var table = "_3m-i";
export var tableContainer = "_3m-d";
export var tertiaryText = "_3m-1";